<body style="background-color: #EFEFEF; box-shadow: 0px 1000px 0px 1000px #EFEFEF;">
<router-outlet></router-outlet>